import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

/** BE contract §2 COD: DRAFT -> SETTLED | DISPUTED | WRITTEN_OFF. There is no SUBMITTED status (O101, O104). */
export type CodReconStatus = "DRAFT" | "SETTLED" | "DISPUTED" | "WRITTEN_OFF";

/** perDnBreakdown line as stored (BE contract §2 COD, O103); `deliveryNoteRefCode` is added by GET. */
export interface ICodBreakdownLine {
  deliveryNoteId: string;
  deliveryNoteRefCode?: string | null;
  codAmount: number | string | null;
  codPaymentMethod: string | null;
  capturedAt: string | null;
}
export type SettleDecision = "SETTLED" | "DISPUTED" | "WRITTEN_OFF";

export interface ICodReconciliation {
  id: string;
  businessId: string;
  driverUserId: string;
  workDate: string;
  status: CodReconStatus;
  expectedAmount: number;
  actualAmount: number;
  discrepancyAmount: number;
  deliveryCount: number;
  perDnBreakdown: ICodBreakdownLine[];
  reconciledByUserId: string;
  reconciledAt: string;
  settledAt: string | null;
  settledByUserId: string | null;
  notes: string | null;
  driverSignatureUrl: string | null;
  cashierSignatureUrl: string | null;
  custodyTransferId: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface IListFilters {
  filter?: {
    status?: string | null;
    driverUserId?: string | null;
    workDateFrom?: string | null;
    workDateTo?: string | null;
  };
  offset?: {
    limit?: number;
    skip?: number;
  };
}

export interface ISettlePayload {
  decision: SettleDecision;
  notes?: string | null;
  cashierSignatureUrl?: string | null;
  driverSignatureUrl?: string | null;
  custodyTransferId?: string | null;
}

export const list = async (filters: IListFilters = {}) =>
  httpRequest.post("/ord/cod-reconciliation/list", filters as never) as Promise<{
    rows: ICodReconciliation[];
    count: number;
  }>;

export const get = async (id: string): Promise<ICodReconciliation> =>
  httpRequest.get(`/ord/cod-reconciliation/${id}`);

export const settle = async (
  id: string,
  payload: ISettlePayload,
): Promise<ICodReconciliation> =>
  httpRequest.post(`/ord/cod-reconciliation/${id}/settle`, payload as never);
